import * as tslib_1 from "tslib";
import { FuseConfigService } from '@fuse/services/config.service';
import { LoginCustomizationService } from 'app/main/settings/accounts/preferences/services/login-customization.service';
import { sentry } from 'sentry';
import * as i0 from "@angular/core";
import * as i1 from "../../settings/accounts/preferences/services/login-customization.service";
import * as i2 from "../../../../@fuse/services/config.service";
var LoginResolver = /** @class */ (function () {
    function LoginResolver(loginCustomizationService, fuseConfigService) {
        this.loginCustomizationService = loginCustomizationService;
        this.fuseConfigService = fuseConfigService;
        this.loginCustomization = null;
    }
    LoginResolver.prototype.resolve = function (_route, _state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.hideToolbarAndNavbar();
                        _a = this;
                        return [4 /*yield*/, this.loginCustomizationService.loginCustomizationBySlug()];
                    case 1:
                        _a.loginCustomization = _b.sent();
                        return [2 /*return*/, this.loginCustomization];
                    case 2:
                        err_1 = _b.sent();
                        sentry.captureException(err_1);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoginResolver.prototype.hideToolbarAndNavbar = function () {
        this.fuseConfigService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true }
            }
        };
    };
    LoginResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginResolver_Factory() { return new LoginResolver(i0.ɵɵinject(i1.LoginCustomizationService), i0.ɵɵinject(i2.FuseConfigService)); }, token: LoginResolver, providedIn: "root" });
    return LoginResolver;
}());
export { LoginResolver };
